export default __webpack_public_path__ + "static/media/Mockup_1.619b5ba3.png";